<template>
  <div v-if="hasSelectedCourse">
    <v-toolbar class="pl-nav-content white" flat light app fixed>
      <v-toolbar-title>Categorias</v-toolbar-title>
      <v-spacer></v-spacer>
      <category-form/>
    </v-toolbar>
    <category-list/>
  </div>

  <div v-else>
    <div class="pl-intro">
      <p class="pl-intro-text">
        Selecione o <strong>Curso</strong> da sua biblioteca para
        acessar os <strong>Ranges</strong> específicos:
      </p>

      <v-menu offset-y>
        <v-btn
          class="pl-intro-btn"
          color="success"
          depressed
          large
          slot="activator">
            <span>{{ selectedCourseTitle }}</span>
            <v-icon right dark>expand_more</v-icon>
        </v-btn>

        <v-list class="v-list--large">
          <v-list-tile
            v-for="course in courses"
            :key="course.id"
            @click="selectCourse(course)">
            <v-list-tile-title v-text="course.text"></v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CategoryList from '@/components/Category/CategoryList'
import CategoryForm from '@/components/Category/CategoryForm'

export default {
  name: 'CategoryIndex',

  components: {
    CategoryList,
    CategoryForm
  },

  props: [
    'courses',
    'hasSelectedCourse',
    'selectedCourseTitle'
  ],

  methods: {
    ...mapActions('courses', ['setCourse']),
    ...mapActions('categories', ['getCategories']),

    selectCourse (course) {
      this.setCourse(course)
      this.getCategories(course)

      if (this.$router.history.current.name !== 'home') {
        this.$router.replace({ name: 'home' })
      }
    }
  }
}
</script>
